


















import gql from 'graphql-tag';
import * as R from 'ramda';
import Vue from 'vue';

interface Category {
  id: string;
  name: string;
  categories: Category[];
}

interface TreeData {
  children?: TreeData[];
  isLeaf: boolean;
  key: string;
  title: string;
  value: string;
}

const query = gql`
  query {
    listCategory {
      id
      name
      categories {
        id
        name
        categories {
          id
          name
          categories {
            id
            name
            categories {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export default Vue.extend({
  props: {
    value: String as () => string,
  },

  apollo: {
    listCategory: {
      query,
      fetchPolicy: 'cache-first',
    },
  },

  data() {
    return {
      listCategory: [] as Category[] | undefined,
    };
  },

  computed: {
    categories(): TreeData[] {
      const getCategories: (list: Category[]) => TreeData[] = R.map<
        Category,
        TreeData
      >((c) => {
        const children = getCategories(c.categories);
        return {
          isLeaf: children.length === 0,
          key: c.id,
          title: c.name,
          value: c.id,
          children,
        };
      });

      return this.listCategory ? getCategories(this.listCategory) : [];
    },
  },

  methods: {
    onChange(val: string) {
      this.$emit('change', val);
      this.$emit('input', val);
    },
  },
});
